import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

const api = axios.create({
  baseURL: API_URL,
});

// Request interceptor to add auth headers
api.interceptors.request.use(
  (config) => {
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('sessionToken');

    if (userId && token) {
      config.headers['X-User-ID'] = userId;
      config.headers['X-Auth-Token'] = token;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle 401 errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth and redirect to home
      localStorage.removeItem('userId');
      localStorage.removeItem('sessionToken');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default api;
